import { useState } from 'react'
import { listFacePresets, getFaceAvatar } from '../../utils/avatarFaces'

const PAGE = 12 // grilla 4x3

// open, currentSeed, onClose, onSelect(seedOrNull)
export default function AvatarPickerModal({ open, currentSeed, onClose, onSelect }) {
  const [page, setPage] = useState(0)
  if (!open) return null
  const presets = listFacePresets()
  const pages = Math.max(1, Math.ceil(presets.length / PAGE))
  const safePage = Math.min(page, pages - 1)
  const slice = presets.slice(safePage * PAGE, safePage * PAGE + PAGE)
  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center" onClick={onClose}>
      <div className="bg-white dark:bg-surface-dark rounded-lg shadow-2xl max-w-md w-full mx-4" onClick={e => e.stopPropagation()}>
        <div className="bg-gradient-to-r from-primary-600 to-primary-700 text-white px-5 py-3 rounded-t-lg flex items-center justify-between">
          <h3 className="font-semibold">Elegir avatar</h3>
          <button onClick={onClose} className="text-white/80 hover:text-white text-xl leading-none">×</button>
        </div>
        <div className="p-4">
          <div className="grid grid-cols-4 gap-3">
            {slice.map(p => (
              <button key={p.id} onClick={() => onSelect(p.id)} title={p.bucket}
                className={`aspect-square rounded-xl overflow-hidden border-2 transition hover:scale-105 ${currentSeed === p.id ? 'border-primary-500 ring-2 ring-primary-300' : 'border-gray-200 dark:border-gray-700'}`}>
                <img src={getFaceAvatar(p.id)} alt={p.id} draggable={false}
                     className="w-full h-full object-cover bg-gray-50 dark:bg-gray-800" />
              </button>
            ))}
          </div>
          <div className="flex items-center justify-between mt-4">
            <button onClick={() => onSelect(null)}
              className="text-sm px-3 py-1.5 rounded-lg text-rose-600 dark:text-rose-400 hover:bg-rose-50 dark:hover:bg-rose-900/30">
              Quitar (usar iniciales)
            </button>
            <div className="flex items-center gap-2">
              <button disabled={safePage === 0} onClick={() => setPage(safePage - 1)} aria-label="Página anterior"
                className="w-10 h-10 flex items-center justify-center rounded-lg border border-gray-300 dark:border-gray-600 text-2xl leading-none font-semibold disabled:opacity-30 hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-700 dark:text-gray-200">‹</button>
              <span className="text-sm font-medium text-gray-600 dark:text-gray-300 min-w-[2.75rem] text-center tabular-nums">{safePage + 1}/{pages}</span>
              <button disabled={safePage >= pages - 1} onClick={() => setPage(safePage + 1)} aria-label="Página siguiente"
                className="w-10 h-10 flex items-center justify-center rounded-lg border border-gray-300 dark:border-gray-600 text-2xl leading-none font-semibold disabled:opacity-30 hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-700 dark:text-gray-200">›</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
